import React from 'react';
import PropTypes from 'prop-types';
import Typist from 'react-typist';

class TypistLoop extends React.Component {
  state = {
    isTyping: true,
  };

  componentWillMount() {
    this.timeouts = [];
  }

  componentWillUnmount() {
    this.timeouts.forEach(window.clearTimeout);
  }

  done = () => {
    this.setState({ isTyping: false }, () => {
      this.timeouts.push(setTimeout(() => this.setState({ isTyping: true }), 500));
    });
  };

  render() {
    const { children, ...props } = this.props;

    return this.state.isTyping ? (
      <Typist {...props} onTypingDone={this.done}>
        {children}
      </Typist>
    ) : (
      <span>|</span>
    );
  }
}

TypistLoop.defaultProps = {
  children: '',
};

TypistLoop.propTypes = {
  children: PropTypes.node,
};

export default TypistLoop;



// WEBPACK FOOTER //
// ./src/components/TypistLoop.js